import { render, staticRenderFns } from "./relatedReading.vue?vue&type=template&id=ae405196&scoped=true&"
import script from "./relatedReading.vue?vue&type=script&lang=js&"
export * from "./relatedReading.vue?vue&type=script&lang=js&"
import style0 from "./relatedReading.vue?vue&type=style&index=0&id=ae405196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae405196",
  null
  
)

export default component.exports